<div class="body">

    <div class="content" *ngIf="(service.mails$|async)?.length > 0; else noMails">

        <div class="mail-list" *ngIf="!toggled" @show>

            <div *ngFor="let mail of (service.mails$|async|sortEMails)" class="mail-label-wrapper" [class.active]="currentMailId === mail.messageId" (click)="setMail(mail)">
    
                <app-mail-label class="mail-wrapper" [mail]="mail"></app-mail-label>
    
            </div>
    
        </div>
    
        <div class="mail-content">
    
            <ng-container *ngIf="mailBody; else noBody">

                <div class="mail-content-inner">
                    <quill-view [content]="mailBody" format="html" class="quill-note"></quill-view>
                </div>

            </ng-container>
    
        </div>

    </div>

</div>

<ng-template #noMails>

    <div class="no-mails-hint">

        <span>Keine E-Mails</span>

    </div>

</ng-template>

<ng-template #noBody>

    <div class="no-body-hint">
        Keine E-Mail gewählt
    </div>

</ng-template>
